<template>
  <div v-if="oidcIsAuthenticated" class="overview-header" :class="opacityClass">
    <SideBarToggle class="sidebar-toggle v-step-8--mobile" />
    <div class="container header-container">
      <div class="header-container__left">
        <h1>Suspicious traffic</h1>
        <MonthSelection id="v-step-2" v-if="!(noAccount || noASN)" />
      </div>
      <div class="header-container__right" v-if="!(noAccount || noASN)">
        <ReportButton id="v-step-7" :disabled="noAccount"></ReportButton>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../utils/mixin';
import SideBarToggle from '../ui/SidebarToggle';
import ReportButton from '../overview/report/ReportButton';
import MonthSelection from '../MonthSelection';

export default {
  mixins: [mixin],
  data() {
    return {
      opacityClass: ''
    };
  },
  created: function() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 10) {
        this.opacityClass = 'opacity';
      } else {
        this.opacityClass = '';
      }
    }
  },
  components: {
    SideBarToggle,
    ReportButton,
    MonthSelection
  }
};
</script>

<style lang="scss">
.overview-header {
  display: flex;
  position: relative;
  height: 82px;
  position: sticky;
  left: 0;
  top: 50px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  margin-bottom: 6px;
  z-index: 14;
  transition: opacity 0.5s;

  &.opacity {
    opacity: 0.95;
  }

  &:hover {
    opacity: 1;
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__left {
      padding-left: 20px;
      h1 {
        font-size: 34px;
        line-height: 1.2;
        margin-bottom: 5px;

        @media screen and (max-width: 485px) {
          font-size: 24px;
          line-height: 1.1;
          margin-bottom: 0;
        }
      }
    }

    &__right {
      button {
        min-width: auto;
        padding: 0;
      }
    }
  }

  .ivu-dropdown {
    .ivu-select-dropdown {
      max-width: calc(100vw - 10px);
      border: solid 1px rgba(0, 0, 0, 0.15);
      border-radius: 0;
      box-shadow: none;
      margin: 2px 0;

      .ivu-dropdown-item {
        font-size: 16px !important;

        &:hover {
          background: #e6e6e6;
        }
      }
    }
  }

  .sidebar-toggle {
    position: absolute;
    top: 12px;
    left: 6px;
  }
}
</style>
